const firebaseConfig = {
    apiKey: "AIzaSyAVmPlthd-sOc6NfNQHT2oya8UEP1-yNBo",
    authDomain: "nicsh-bike-sales-service.firebaseapp.com",
    projectId: "nicsh-bike-sales-service",
    storageBucket: "nicsh-bike-sales-service.appspot.com",
    messagingSenderId: "621954294271",
    appId: "1:621954294271:web:17bdbe8653aad5450e07ca",
    measurementId: "G-R5D9LGHQYD"
  };

  export default firebaseConfig;